import { Typography } from '@/app/components/Typography'
import React from 'react'
import { useIntl } from 'react-intl'

type SignUpBenefitsEdpCampaignProps = React.HTMLAttributes<HTMLDivElement>

export function SignUpBenefitsEdpCampaign(
  props: SignUpBenefitsEdpCampaignProps
) {
  const intl = useIntl()

  return (
    <aside
      {...props}
      className={`flex flex-col gap-5 p-4 text-white text-left rounded-2xl ${props.className ?? ''}`}
    >
      <Typography variant="h2">
        {intl.formatMessage({
          id: 'SignUpBenefits.transform_your_career',
          defaultMessage: 'Transform your career with the energy transition',
        })}
      </Typography>

      <Typography variant="body1" className="font-gt-planar">
        {intl.formatMessage({
          id: 'SignUpBenefits.explore_courses',
          defaultMessage:
            "Explore a carefully designed selection of courses aligned with your career ambitions, while benefiting from our income-based payment plan.Focus on learning and we'll take care of your tuition - enroll today!",
        })}
      </Typography>

      <Typography variant="h5" className="font-bold font-sans" as="p">
        {intl.formatMessage({
          id: 'SignUpBenefits.sign_up_today_and_learn_more',
          defaultMessage:
            'Sign up today and access all the information about our courses and financing plans.',
        })}
      </Typography>
    </aside>
  )
}
